import { useMemo, useState } from "react";
import { FAQS } from "@/data/products";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

export default function FAQ() {
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("All");
  const cats = ["All", ...Array.from(new Set(FAQS.map(f=>f.category)))];
  const list = useMemo(() => FAQS.filter(f => (cat==="All"||f.category===cat) && (!q || f.q.toLowerCase().includes(q.toLowerCase()) || f.a.toLowerCase().includes(q.toLowerCase()))), [q, cat]);
  return (
    <div className="section-y" data-testid="faq-page">
      <div className="container-x max-w-3xl">
        <div className="overline">FAQ</div>
        <h1 className="font-display text-5xl lg:text-6xl text-sage-800 mt-3">Answers, straight up.</h1>
        <div className="mt-8 relative">
          <Search className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-sage-800/50" />
          <Input placeholder="Search FAQs…" value={q} onChange={(e)=>setQ(e.target.value)} className="pl-10 h-12 rounded-full bg-white border-sand-300" data-testid="faq-search" />
        </div>
        <div className="mt-6 flex gap-2 flex-wrap">
          {cats.map(c=>(
            <button key={c} onClick={()=>setCat(c)} data-testid={`faq-cat-${c.replace(/\s+/g,'-').toLowerCase()}`} className={`btn-pill text-xs px-4 py-2 border ${cat===c?"bg-sage-700 text-white border-sage-700":"border-sand-300 text-sage-800 bg-white hover:bg-sand-100"}`}>{c}</button>
          ))}
        </div>
        <Accordion type="single" collapsible className="mt-8">
          {list.map((f, i)=>(
            <AccordionItem key={i} value={`i${i}`} className="border-sand-200">
              <AccordionTrigger className="text-left text-sage-800 hover:no-underline">{f.q}</AccordionTrigger>
              <AccordionContent className="text-sage-800/70">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
